export default __webpack_public_path__ + "static/media/AdnanQureshi.ca061439.png";